import React from "react";

const extractVideoId = (value) => {
  if (!value) return "";

  const input = value.trim();

  // Already a YouTube video ID.
  if (/^[a-zA-Z0-9_-]{11}$/.test(input)) {
    return input;
  }

  try {
    const url = new URL(input);

    // youtube.com/shorts/VIDEO_ID
    const shortsMatch = url.pathname.match(
      /\/shorts\/([a-zA-Z0-9_-]{11})/
    );

    if (shortsMatch) {
      return shortsMatch[1];
    }

    // youtube.com/watch?v=VIDEO_ID
    const watchId = url.searchParams.get("v");

    if (watchId && /^[a-zA-Z0-9_-]{11}$/.test(watchId)) {
      return watchId;
    }

    // youtube.com/embed/VIDEO_ID
    const embedMatch = url.pathname.match(
      /\/embed\/([a-zA-Z0-9_-]{11})/
    );

    if (embedMatch) {
      return embedMatch[1];
    }

    // youtu.be/VIDEO_ID
    const shortMatch = url.pathname.match(
      /\/([a-zA-Z0-9_-]{11})/
    );

    if (shortMatch) {
      return shortMatch[1];
    }
  } catch (error) {
    console.error("Invalid YouTube URL:", error);
  }

  return "";
};

const YoutubePlayer = () => {
  const params = new URLSearchParams(window.location.search);

  // Supported:
  // /youtube-player?videoId=VIDEO_ID
  // /youtube-player?v=VIDEO_ID
  // /youtube-player?url=https://youtube.com/shorts/VIDEO_ID
  const input =
    params.get("videoId") ||
    params.get("v") ||
    params.get("url") ||
    "";

  const videoId = extractVideoId(input);

  if (!videoId) {
    return (
      <div style={styles.page}>
        <div style={styles.message}>
          <div style={styles.title}>Video unavailable</div>
          <div style={styles.description}>
            Invalid YouTube video.
          </div>
        </div>
      </div>
    );
  }

  // IMPORTANT:
  // This page is hosted on the real PITICS public HTTPS origin.
  // The actual origin is used automatically so the YouTube
  // enablejsapi origin always matches the domain serving this page.
  const origin = window.location.origin;

  const youtubeUrl =
    `https://www.youtube.com/embed/${videoId}` +
    `?playsinline=1` +
    `&autoplay=0` +
    `&rel=0` +
    `&modestbranding=1` +
    `&enablejsapi=1` +
    `&origin=${encodeURIComponent(origin)}`;

  return (
    <div style={styles.page}>
      <div style={styles.playerContainer}>
        <iframe
          title="PITICS YouTube Short"
          src={youtubeUrl}
          style={styles.iframe}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    </div>
  );
};

const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: 0,
    margin: 0,
  },

  playerContainer: {
    width: "min(100vw, 420px)",
    aspectRatio: "9 / 16",
    maxHeight: "100vh",
    backgroundColor: "#000",
    overflow: "hidden",
    position: "relative",
  },

  iframe: {
    width: "100%",
    height: "100%",
    border: 0,
    display: "block",
  },

  message: {
    textAlign: "center",
    color: "#fff",
    padding: "24px",
    fontFamily: "Arial, sans-serif",
  },

  title: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "8px",
  },

  description: {
    fontSize: "14px",
    color: "#bbb",
  },
};

export default YoutubePlayer;
